
import { defineComponent, PropType } from 'vue'

import {
  Analyzer,
  AnalyzerConnection,
  IssueOccurrenceFrequency,
  Maybe,
  Run,
  RunConnection,
  VcsProviderChoices
} from '~/types/types'
import { resolveNodes } from '~/utils/array'

export default defineComponent({
  name: 'MetadataViewMobile',
  data() {
    return {
      metadataTextEntries: [
        'Analysis status',
        'Source',
        'Active issues',
        'Issues prevented',
        'Default branch',
        'Analyzers'
      ]
    }
  },
  props: {
    issuesPrevented: {
      type: [String, Number] as PropType<string | number>,
      default: ''
    },
    isActivated: {
      type: Boolean,
      default: false
    },
    defaultBranchName: {
      type: String,
      default: ''
    },
    availableAnalyzers: {
      type: Object as PropType<Maybe<AnalyzerConnection>>,
      default: null
    },
    vcsProvider: {
      type: String as PropType<VcsProviderChoices>,
      default: ''
    },
    latestAnalysisRun: {
      type: Object as PropType<Maybe<Run>>,
      default: null
    },
    runs: {
      type: Object as PropType<Maybe<RunConnection>>,
      default: {}
    },
    issueOccurrenceDistributionByIssueType: {
      type: Array as PropType<Array<IssueOccurrenceFrequency>>,
      default: () => []
    }
  },
  computed: {
    analyzers(): Array<Analyzer> {
      return resolveNodes(this.availableAnalyzers)
    },
    othersList() {
      const initialListCount = 4
      return this.analyzers.slice(initialListCount)
    },
    initialList() {
      const initialListCount = 4
      return this.analyzers.slice(0, initialListCount)
    },
    totalIssueCount(): number | undefined {
      const distributionEntries = this.issueOccurrenceDistributionByIssueType.find(
        ({ key }) => key === 'all'
      )
      return distributionEntries?.count ?? 0
    },
    vcsProviderIcon() {
      return this.$providerMetaMap[this.vcsProvider]?.icon ?? ''
    },
    vcsProviderText() {
      return this.$providerMetaMap[this.vcsProvider]?.text ?? ''
    }
  }
})
